/**
 * Customer pre-fill voor inschrijfformulieren (hockeykamp + hockeyschool + USA camp).
 *
 * Leest het JSON-data-eiland uit snippets/customer-prefill.liquid en vult de
 * ouder/verzorger-velden met profielgegevens. Kindprofielen zijn AANVINKBAAR
 * (meerdere tegelijk): elk aangevinkt kind krijgt zijn eigen deelnemer-blok,
 * automatisch ingevuld, met een rode check-melding ("Check club, team en
 * shirtmaat") in het blok. Uitvinken verwijdert het blok weer.
 *
 * Blokbeheer komt van multi-participant.js via form.__participants
 * (add/remove/count). Formulieren zonder deelnemer-blokken (USA camp)
 * gedragen zich als single-select: één kind tegelijk, form-breed ingevuld.
 *
 * "Reeds deelnemer?" wordt per kind gezet op basis van de bestelgeschiedenis.
 */
(function () {
  'use strict';

  // Deelnemer-velden: input-naam -> sleutel in het kindprofiel.
  // Inputs heten name="properties[Veldnaam]" (evt. met ~N-suffix per blok).
  var PARTICIPANT_MAP = {
    'Voornaam': 'voornaam',
    'Achternaam': 'achternaam',
    'Geslacht': 'geslacht',
    'Geboortedatum': 'geboortedatum',
    'Email deelnemer': 'email',
    'Hockeyvereniging': 'hockeyvereniging',
    'Hockeyclub': 'hockeyvereniging',
    'Team': 'team',
    'Shirtmaat': 'kledingmaat',
    'Dieet allergieen medicijnen': 'allergieen'
  };

  // Ouder/verzorger-velden: input-naam -> sleutel in het ouder-object.
  var PARENT_MAP = {
    'Voornaam ouder': 'voornaam',
    'Achternaam ouder': 'achternaam',
    'Email ouder': 'email',
    'Extra email ouder': 'extra_email',
    'Telefoon ouder': 'telefoon',
    'Extra telefoon ouder': 'extra_telefoon',
    'Adres ouder': 'adres',
    'Plaats ouder': 'plaats',
    'Postcode ouder': 'postcode'
  };

  // De gedelegeerde change-listener zit op document; init() draait opnieuw
  // bij shopify:section:load (sectie-herlaad in de theme editor), dus zonder
  // deze vlag zou dat een tweede identieke listener registreren en elke
  // checkbox-toggle dubbel afhandelen.
  var changeDelegateBound = false;

  /**
   * `root` beperkt de herinitialisatie tot één sectie: shopify:section:load
   * geeft de vervangen sectie mee als event.target. Setup() bindt alleen een
   * click-listener op een node binnen de (verse) sectie zelf, dus scopen
   * voorkomt dat een herlaad elders op de pagina niet-vervangen wrappers
   * nogmaals initialiseert.
   */
  function init(root) {
    (root || document).querySelectorAll('[data-customer-prefill]').forEach(setup);

    // Delegation zodat de checkboxes ook na DOM-wijzigingen blijven werken.
    if (!changeDelegateBound) {
      changeDelegateBound = true;
      document.addEventListener('change', function (e) {
        var checkbox = e.target.closest && e.target.closest('[data-prefill-child]');
        if (checkbox) onChildToggle(checkbox);
      });
    }
  }

  function setup(wrapper) {
    var dataNode = wrapper.querySelector('[data-customer-prefill-data]');
    if (!dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (e) {
      console.warn('[customer-prefill] ongeldig data-eiland', e);
      return;
    }

    var formId = wrapper.dataset.targetForm;
    var form = formId ? document.getElementById(formId) : wrapper.closest('form');
    if (!form) {
      console.warn('[customer-prefill] doelformulier niet gevonden:', formId);
      return;
    }

    form.__prefillData = data;

    // Ouder/verzorger-velden staan buiten de deelnemer-blokken: form-breed vullen.
    fillFromMap(form, PARENT_MAP, buildParent(data));

    var fastCta = wrapper.querySelector('[data-prefill-fast-cta]');
    if (fastCta) {
      fastCta.addEventListener('click', function () { scrollToSubmit(form); });
    }
  }

  function onChildToggle(checkbox) {
    var form = checkbox.closest('form');
    if (!form || !form.__prefillData) return;
    var data = form.__prefillData;
    var idx = checkbox.dataset.prefillChild;
    var child = (data.children || [])[parseInt(idx, 10)] || null;
    var api = form.__participants || null;

    if (!api) {
      // Geen deelnemer-blokken (USA camp): één kind tegelijk, form-breed.
      form.querySelectorAll('[data-prefill-child]').forEach(function (other) {
        if (other !== checkbox) other.checked = false;
      });
      fillChild(form, form, checkbox.checked ? child : null, data);
      refreshFastCta(form);
      return;
    }

    if (checkbox.checked && child) {
      var block = claimBlock(form, api, idx);
      if (block) fillChild(form, block, child, data);
    } else {
      var owned = form.querySelector('[data-participant][data-child-idx="' + idx + '"]');
      if (owned) {
        if (api.count() > 1) {
          api.remove(owned);
        } else {
          clearBlock(owned);
        }
      }
    }
    refreshFastCta(form);
  }

  // Hergebruik een leeg, niet-geclaimd blok (bv. het startblok); anders nieuw blok.
  function claimBlock(form, api, idx) {
    var block = null;
    form.querySelectorAll('[data-participant]').forEach(function (b) {
      if (block || b.dataset.childIdx) return;
      var first = b.querySelector('[name^="properties[Voornaam]"]');
      if (first && first.value.trim() === '') block = b;
    });
    if (!block) block = api.add();
    if (block) block.dataset.childIdx = idx;
    return block;
  }

  function fillChild(form, scope, child, data) {
    fillFromMap(scope, PARTICIPANT_MAP, child || {});

    var alertEl = scope.querySelector ? scope.querySelector('[data-prefill-alert]') : null;
    if (alertEl) alertEl.hidden = !child;

    if (!child) {
      scope.querySelectorAll('input[type="radio"][name^="properties[Reeds deelnemer]"]').forEach(function (r) {
        r.checked = false;
      });
      return;
    }

    // "Reeds deelnemer?" automatisch zetten op basis van bestelgeschiedenis.
    var registered = isAlreadyRegistered(child, data.registrations);
    setRadio(
      scope,
      'Reeds deelnemer',
      registered
        ? 'Reeds deelnemer, shirt al ontvangen'
        : 'Nieuwe deelnemer of shirt nog niet ontvangen'
    );
    // setRadio zet .checked direct (geen change-event), dus de shirtmaat-reveal
    // van multi-participant.js expliciet in sync zetten met de nieuwe keuze.
    if (form.__participants && form.__participants.syncShirtmaat) {
      form.__participants.syncShirtmaat(scope);
    }

    // Toestemming beeldmateriaal: form-breed veld (geldt voor de bestelling).
    if (child.toestemming_beeldmateriaal) {
      setRadio(form, 'Toestemming beeldmateriaal', child.toestemming_beeldmateriaal);
    }
  }

  function clearBlock(block) {
    fillFromMap(block, PARTICIPANT_MAP, {});
    block.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
    var alertEl = block.querySelector('[data-prefill-alert]');
    if (alertEl) alertEl.hidden = true;
    delete block.dataset.childIdx;
    // Radio's hierboven direct uitgevinkt (geen change-event): shirtmaat-reveal
    // expliciet terugzetten naar verborgen, anders blijft 'm zichtbaar staan.
    var form = block.closest('form');
    if (form && form.__participants && form.__participants.syncShirtmaat) {
      form.__participants.syncShirtmaat(block);
    }
  }

  function refreshFastCta(form) {
    var wrapper = form.querySelector('[data-customer-prefill]');
    if (!wrapper) return;
    var fastCta = wrapper.querySelector('[data-prefill-fast-cta]');
    if (!fastCta) return;
    var label = wrapper.querySelector('.customer-prefill__fast-cta-label');
    var checked = wrapper.querySelectorAll('[data-prefill-child]:checked');

    if (!checked.length) {
      fastCta.hidden = true;
      return;
    }
    if (label) {
      if (checked.length === 1) {
        var nameEl = checked[0].closest('label');
        var name = nameEl && nameEl.querySelector('.customer-prefill__child-name');
        label.textContent = 'Direct doorgaan met ' + (name ? name.textContent.trim() : '1 kind');
      } else {
        label.textContent = 'Direct doorgaan met ' + checked.length + ' kinderen';
      }
    }
    fastCta.hidden = false;
  }

  // Voegt klant- en profielgegevens samen tot één ouder/verzorger-object.
  function buildParent(data) {
    var c = data.customer || {};
    var p = data.profile || {};
    return {
      voornaam: c.first_name,
      achternaam: c.last_name,
      email: c.email,
      extra_email: p.extra_email,
      telefoon: p.telefoon,
      extra_telefoon: p.extra_telefoon,
      adres: p.adres,
      plaats: p.plaats,
      postcode: p.postcode
    };
  }

  function scrollToSubmit(form) {
    var submitBtn = form.querySelector('[type="submit"]');
    if (!submitBtn) return;
    submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      var requiredFields = form.querySelectorAll('[required]');
      var firstEmpty = null;
      requiredFields.forEach(function (field) {
        if (field.disabled) return; // hidden/disabled select (e.g. shirt size when unavailable) is never the real next field
        if (field.type === 'radio') {
          var groupChecked = form.querySelectorAll('[name="' + field.name + '"]:checked').length > 0;
          if (!groupChecked && !firstEmpty) firstEmpty = field;
        } else if (field.type === 'checkbox') {
          if (!field.checked && !firstEmpty) firstEmpty = field;
        } else if (!field.value) {
          if (!firstEmpty) firstEmpty = field;
        }
      });
      if (firstEmpty) {
        firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof firstEmpty.focus === 'function') firstEmpty.focus();
      } else if (typeof submitBtn.focus === 'function') {
        submitBtn.focus();
      }
    }, 400);
  }

  function normalize(s) {
    return (s == null ? '' : String(s)).trim().toLowerCase();
  }

  // Bepaalt of dit kind al eerder is ingeschreven (op voornaam + geboortedatum,
  // binnen de eigen bestellingen). Zo ja -> geen nieuw shirt.
  function isAlreadyRegistered(child, registrations) {
    if (!Array.isArray(registrations) || !registrations.length) return false;
    var cv = normalize(child.voornaam);
    if (!cv) return false;
    var cd = normalize(child.geboortedatum);
    return registrations.some(function (r) {
      if (normalize(r.voornaam) !== cv) return false;
      if (cd && normalize(r.geboortedatum)) {
        return normalize(r.geboortedatum) === cd;
      }
      return true;
    });
  }

  // Prefix-match: radio-namen kunnen per blok een ~N-suffix hebben.
  function setRadio(scope, propName, value) {
    var radios = scope.querySelectorAll('input[type="radio"][name^="properties[' + propName + ']"]');
    radios.forEach(function (r) {
      r.checked = (r.value === value);
    });
  }

  function fillFromMap(scope, map, source) {
    Object.keys(map).forEach(function (fieldName) {
      var sourceKey = map[fieldName];
      var value = source[sourceKey];
      var input = scope.querySelector('[name="properties[' + fieldName + ']"]');
      if (!input) return;

      if (value === undefined || value === null || value === '') {
        if (input.tagName === 'SELECT') {
          input.selectedIndex = 0;
        } else {
          input.value = '';
        }
        return;
      }

      if (input.tagName === 'SELECT') {
        var option = Array.from(input.options).find(function (opt) {
          return opt.value === String(value) || opt.textContent.trim() === String(value);
        });
        if (option) input.value = option.value;
      } else {
        input.value = String(value);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Herinitialiseert alleen de zojuist herladen sectie (theme editor). Dit
  // script laadt eenmalig via layout/theme.liquid en draait niet opnieuw bij
  // een section-herlaad, dus deze registratie zelf kan niet dubbel lopen.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
